import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../ui/dialog';
import { Button } from '../ui/button';
import { Textarea } from '../ui/textarea';
import { API_URL, OUTCOMES } from './pendShared';

const MODES = {
  seguimento: { title: 'Dar seguimento', desc: 'Diga o que fez. A situação fica em "Pendente de resolução" até a concluir.', btn: 'Registar seguimento' },
  concluir: { title: 'Concluir pendência', desc: 'Escolha o resultado e explique.', btn: 'Concluir' },
  justificar: { title: 'Justificar atraso', desc: 'O prazo de 24h terminou. A justificação é obrigatória.', btn: 'Enviar justificação' },
};

export const PendNoteDialog = ({ pend, mode, onClose, onDone }) => {
  const [note, setNote] = useState('');
  const [outcome, setOutcome] = useState('');
  const [saving, setSaving] = useState(false);
  useEffect(() => { setNote(''); setOutcome(''); }, [pend?.id, mode]);
  if (!pend || !mode) return null;
  const m = MODES[mode];
  const ok = note.trim().length >= 10 && (mode !== 'concluir' || outcome);

  const save = async () => {
    setSaving(true);
    try {
      await axios.post(`${API_URL}/pendencias/${pend.id}/${mode}`, { note: note.trim(), outcome: outcome || null });
      toast.success('Registado');
      window.dispatchEvent(new Event('pendencias-changed'));
      onDone?.();
      onClose();
    } catch (e) {
      toast.error((typeof e.response?.data?.detail === 'string' && e.response.data.detail) || 'Erro ao guardar');
    } finally { setSaving(false); }
  };

  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg" data-testid={`pend-note-dialog-${mode}`}>
        <DialogHeader>
          <DialogTitle>{m.title}</DialogTitle>
          <DialogDescription>{pend.client_name} · {pend.situacao}. {m.desc}</DialogDescription>
        </DialogHeader>
        {mode === 'concluir' && (
          <div className="grid grid-cols-2 gap-2" data-testid="pend-outcomes">
            {Object.entries(OUTCOMES).map(([k, v]) => (
              <button key={k} onClick={() => setOutcome(k)} data-testid={`pend-outcome-${k}`}
                className={`text-sm p-2 rounded-lg border transition-colors ${outcome === k ? 'border-[#2D3E6F] bg-[#2D3E6F] text-white' : 'border-slate-200 hover:border-[#4DD4E8]'}`}>{v}</button>
            ))}
          </div>
        )}
        <Textarea rows={4} value={note} onChange={(e) => setNote(e.target.value)} placeholder="Mínimo 10 caracteres" data-testid="pend-note-textarea" />
        <p className={`text-xs ${note.trim().length < 10 ? 'text-rose-600' : 'text-emerald-600'}`}>{note.trim().length}/10 caracteres</p>
        <div className="flex justify-end gap-2">
          <Button variant="outline" onClick={onClose} data-testid="pend-note-cancel">Cancelar</Button>
          <Button onClick={save} disabled={!ok || saving} className="bg-[#2D3E6F]" data-testid="pend-note-submit">
            {saving && <Loader2 className="w-4 h-4 animate-spin" />}{m.btn}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
